import BookingText from './BookingText';
import BookingCard from './BookingCard';
import SectionStructure from '../../../components/Section/SectionStructure';


export default function SectionBooking() {

    
return (

 <SectionStructure
    
            sectiontext=    { <BookingText />}
            

            sectioncards=  {<>

                        <BookingCard />

            </> }
        />
    )
}